import { render } from "./AddEditEmployee.vue?vue&type=template&id=379cd11a"
import script from "./AddEditEmployee.vue?vue&type=script&lang=js"
export * from "./AddEditEmployee.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__